import { createContext } from 'react';
import { UserInfo } from '../constants/types';

export type AuthContextType = {
  user: UserInfo | null;
  loading: boolean;
  login: (user: UserInfo) => void;
  logout: () => void;
};

export const AuthContext = createContext<AuthContextType>({ user: null, loading: false, login: () => {}, logout: () => {} });
